var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7531.44,-1769.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-black",
    transform: "matrix(0.145417,0,0,0.186342,7127.92,1709.97)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49017.2,-9176.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7547.44,1784.07L7535.91,1772.54C7535.65,1772.28 7535.23,1772.28 7534.97,1772.54C7534.71,1772.8 7534.71,1773.22 7534.97,1773.48L7546.5,1785.01L7534.97,1796.54C7534.71,1796.8 7534.71,1797.22 7534.97,1797.48C7535.23,1797.74 7535.65,1797.74 7535.91,1797.48L7547.44,1785.95L7558.97,1797.48C7559.23,1797.74 7559.65,1797.74 7559.91,1797.48C7560.17,1797.22 7560.17,1796.8 7559.91,1796.54L7548.38,1785.01L7559.91,1773.48C7560.17,1773.22 7560.17,1772.8 7559.91,1772.54C7559.65,1772.28 7559.23,1772.28 7558.97,1772.54L7547.44,1784.07Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c2a283d01f8b047f13cff94cf429b6dd.svg";
export { ForwardRef as ReactComponent };